<h2 fxLayoutGap="12px" fxLayoutAlign="start center" style="margin-bottom: 24px">
  <span fxFlex>Property Search</span>
  <sbnb-button size="mini" [loading]="saving" (click)="save()">Save</sbnb-button>
</h2>

<sbnb-helptext-wrapper
  *ngIf="parentType === 'custom'"
  class="helptext-wrapper-type-content"
  [area]="'content'"
  [pageId]="'direct-custom-site-edit-search'"></sbnb-helptext-wrapper>

<section *ngIf="widget" fxLayout="column" fxLayoutGap="24px">
  <div *ngIf="parentType !== 'custom'" fxLayout="column">
    <mat-slide-toggle [(ngModel)]="widget.enabled">
      <strong>Enable Property Search</strong>
    </mat-slide-toggle>

    <span class="text__small night-lighter">
      Enabling this will show a property search widget on the homepage of your site.
    </span>
  </div>

  <div *ngIf="parentType === 'custom' && widget.enabled" class="custom-widget-install-instructions">
    <h4 style="margin-bottom: 16px">Installation Instructions</h4>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div fxLayout="row" fxLayoutGap="8px">
              <div class="badge badge-grass-clear">Step 1</div>
              <strong class="night">Create a results page and add the widget</strong>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <span>
          Create a page on your site for property search results. Copy and paste the code below onto this page. When a
          guest searches, results will show up on the page. Clicking on a property result will redirect the guest to the
          property URL that you specified for the property.
        </span>

        <textarea
          class="booking-widget-textarea clickable"
          [matTooltip]="'Click to copy to clipboard'"
          ngxClipboard
          cbContent="&lt;script src=&quot;https://hospitable.b-cdn.net/direct-property-search-widget/hospitable-search-widget.prod.js&quot;&gt;&lt;/script&gt;
&lt;hospitable-direct-mps identifier=&quot;{{ parentId }}&quot; type=&quot;{{
            parentType
          }}&quot;&gt;&lt;/hospitable-direct-mps&gt;">
<script src="https://hospitable.b-cdn.net/direct-property-search-widget/hospitable-search-widget.prod.js"></script>
<hospitable-direct-mps identifier="{{ parentId }}" type="{{ parentType }}"></hospitable-direct-mps></textarea
        >
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div fxLayout="row" fxLayoutGap="8px">
              <div fxFlex="0 0 auto" class="badge badge-grass-clear">Step 2</div>
              <strong class="night">Add a search widget to your homepage (Recommended)</strong>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <span>
          Adding this widget to your homepage or other pages will show only the search bar, and redirect potential
          guests to your results page. Hosts typically use this to embed a small search bar on their homepage, and have
          guests redirected to the results page you setup in Step 1 when they search.
        </span>

        <div style="margin-top: 20px">
          <label>Results page URL</label>
          <mat-form-field class="fw nopadding">
            <input matInput placeholder="/search" [(ngModel)]="resultsPageUrl" />
          </mat-form-field>
        </div>

        <textarea
          class="booking-widget-textarea clickable"
          [matTooltip]="'Click to copy to clipboard'"
          ngxClipboard
          cbContent="&lt;script src=&quot;https://hospitable.b-cdn.net/direct-property-search-widget/hospitable-search-widget.prod.js&quot;&gt;&lt;/script&gt;
&lt;hospitable-direct-mps identifier=&quot;{{ parentId }}&quot; type=&quot;{{ parentType }}&quot; results-url=&quot;{{
            resultsPageUrl
          }}&quot;&gt;&lt;/hospitable-direct-mps&gt;">
<script src="https://hospitable.b-cdn.net/direct-property-search-widget/hospitable-search-widget.prod.js"></script>
<hospitable-direct-mps identifier="{{ parentId }}" type="{{ parentType }}" results-url="{{
            resultsPageUrl
          }}"></hospitable-direct-mps></textarea
        >
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div fxLayout="row" fxLayoutGap="8px">
              <div fxFlex="0 0 auto" class="badge badge-grass-clear">Step 3</div>
              <strong class="night">Pass search terms to your booking widget (Recommended)</strong>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <span>
          When a potential guest selects a property from the search result page, they will be redirected to the property
          page at the URL you specified for the property. If you'd like to pre-populate the search terms (check in &
          check out date, number of guests) on the property page booking widget, you can add the following code to your
          property pages (where the booking widget is installed). This may differ from site to site, but here's an
          example:
        </span>

        <textarea
          class="booking-widget-textarea clickable"
          [matTooltip]="'Click to copy to clipboard'"
          ngxClipboard
          cbContent='&lt;script&gt;
  function getQueryParams(param) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.get(param);
  }

  function updateIframeSrc() {
    const iframe = document.getElementById("booking-iframe");
    if (!iframe) return;

    const checkin = getQueryParams("checkin");
    const checkout = getQueryParams("checkout");
    const adults = getQueryParams("adults");
    const children = getQueryParams("children");
    const infants = getQueryParams("infants");
    const pets = getQueryParams("pets");

    let newSrc = iframe.src;
    newSrc += newSrc.includes("?") ? "&amp;" : "?";
    newSrc += `checkin=${checkin}&amp;checkout=${checkout}&amp;adults=${adults}&amp;children=${children}&amp;pets=${pets}&amp;infants=${infants}`;

    iframe.src = newSrc;
  }

  window.addEventListener("load", updateIframeSrc);
&lt;/script&gt;'>
<script>
  function getQueryParams(param) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.get(param);
  }

  function updateIframeSrc() {
    const iframe = document.getElementById("booking-iframe");
    if (!iframe) return;

    const checkin = getQueryParams("checkin");
    const checkout = getQueryParams("checkout");
    const adults = getQueryParams("adults");
    const children = getQueryParams("children");
    const infants = getQueryParams("infants");
    const pets = getQueryParams("pets");

    let newSrc = iframe.src;
    newSrc += newSrc.includes("?") ? "&" : "?";
    newSrc += `checkin=${checkin}&checkout=${checkout}&adults=${adults}&children=${children}&infants=${infants}&pets=${pets}`;

    iframe.src = newSrc;
  }

  window.addEventListener("load", updateIframeSrc);
</script></textarea
        >
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div fxLayout="column">
    <mat-checkbox
      style="position: relative; left: -8px"
      [ngModel]="!widget.show_map"
      (ngModelChange)="widget.show_map = !$event">
      <strong>Disable map view</strong>
    </mat-checkbox>
  </div>

  <sbnb-direct-location-editor [(locations)]="widget.locations"></sbnb-direct-location-editor>
</section>
